<div class="selection-container" appUserManual [userManualKey]="'supplier-selection'">
  <div class="selected-scope-list card mat-elevation-z2">
    <h3>Selected Scope Assignments</h3>
    <table mat-table [dataSource]="selectedScope" class="mat-elevation-z2 white-surface">
      <ng-container matColumnDef="packageNumber">
        <th mat-header-cell *matHeaderCellDef>Package Number</th>
        <td mat-cell *matCellDef="let scope">{{ scope.procurementPackageNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="tagNumber">
        <th mat-header-cell *matHeaderCellDef>Tag Number</th>
        <td mat-cell *matCellDef="let scope">{{ scope.tagNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="checkSheetNumber">
        <th mat-header-cell *matHeaderCellDef>Checksheet Number</th>
        <td mat-cell *matCellDef="let scope">{{ scope.checkSheetNumber }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['packageNumber', 'tagNumber', 'checkSheetNumber']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['packageNumber', 'tagNumber', 'checkSheetNumber']"></tr>
    </table>
  </div>
  <div class="selection-list card mat-elevation-z2">
    <h3>Available Suppliers</h3>
    <div *ngIf="groupedSuppliers.length === 0" class="empty-state">No suppliers with assigned users available for the selected scope.</div>

    <mat-accordion *ngIf="groupedSuppliers.length > 0" [multi]="true" class="supplier-groups">
      <mat-expansion-panel *ngFor="let group of groupedSuppliers">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ group.vendor.name }}</mat-panel-title>
          <mat-panel-description>{{ group.users.length }} users</mat-panel-description>
        </mat-expansion-panel-header>

        <table mat-table [dataSource]="group.users" class="mat-elevation-z2 white-surface">
          <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef>User Name</th>
            <td mat-cell *matCellDef="let supplier">{{ supplier.userName }}</td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let supplier">{{ supplier.name }}</td>
          </ng-container>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>Select</th>
            <td mat-cell *matCellDef="let supplier">
              <mat-checkbox [checked]="isSelected(supplier)" (change)="onSupplierCheckboxChange($event, supplier)"></mat-checkbox>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['userName', 'name', 'select']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['userName', 'name', 'select']"></tr>
        </table>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
